import styled from 'styled-components';

export const CaseScreenHeaderSubSectionContainer = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  margin: 18px 0 0 0;
  gap: 9px;
`;
